import NewAccountContent from './index.content'
import NewAccountProvider from './index.provider'

const NewAccountScreen: React.FC = () => {
  return (
    <NewAccountProvider>
      <NewAccountContent />
    </NewAccountProvider>
  )
}

export default NewAccountScreen
